var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"menu-icon",attrs:{"to":{ name: 'DashboardSearch' },"title":"Rechercher un profil COOLOC","tag":"div"}},[_c('div',[_c('img',{attrs:{"src":"/static/images/icons/Search.svg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }